import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { isI18nKeyExists } from "@helpers/common";
import { useAppTheme } from "@hooks/useAppTheme";
import type { SkillTypes } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { stimulusIconMap } from "../constants";

const StimulusInfo = ({
	skill,
}: {
	skill?: SkillTypes;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const icon = stimulusIconMap[skill as keyof typeof stimulusIconMap];
	const formattedSkill = skill
		? isI18nKeyExists(`session.stimulusTypes.${skill?.toLowerCase()}`)
			? t(`session.stimulusTypes.${skill?.toLowerCase()}`)
			: skill
		: "";

	if (!formattedSkill) {
		return null;
	}

	return (
		<Box flexDirection="row" alignItems="center" gap={8}>
			<Icon name={icon} size={24} color={theme.colors.text} />
			<Text variant="titleSmall">{`${formattedSkill} ${t("session.attributes.stimulus")}`}</Text>
		</Box>
	);
};

export default StimulusInfo;
